import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';

// Red de seguridad del visor de etiquetas: si el contenido (chunk lazy, pdf.js)
// falla al cargar, el modal sigue visible con una salida (recargar o abrir la
// etiqueta en pestaña nueva) en vez de tumbar toda la app o no mostrar nada.
export default class ViewerErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(err) {
    console.error('[LabelViewer]', err);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const url = '/' + encodeURIComponent(String(this.props.n)) + '.pdf';
    return (
      <div className="flex-1 min-h-0 flex flex-col items-center justify-center gap-3 px-6 text-center bg-ink">
        <AlertTriangle className="w-8 h-8 text-warning" />
        <p className="text-sm text-ink-text">No se pudo cargar el visor de etiquetas.</p>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <button type="button" onClick={() => window.location.reload()}
            className="px-3 h-9 text-sm font-medium bg-cyan text-ink hover:bg-cyan-hover">
            Recargar
          </button>
          <a href={url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center px-3 h-9 text-sm font-medium border border-ink-border text-ink-text hover:bg-ink-inset">
            Abrir en pestaña nueva
          </a>
        </div>
      </div>
    );
  }
}